<template>
  <w-icon-wrapper
    :height='16.95'
    :width='24.001'
    icon-name='work-message-add-icon'
    view-box='0 0 24.001 16.95'
  >
    <defs>
      <clipPath id="clip-path">
        <rect
          id="Rechteck_4037"
          data-name="Rechteck 4037"
          width="24.001"
          height="16.95"
          transform="translate(0 0)"
          fill="none"
        />
      </clipPath>
    </defs>
    <g
      id="Mail_Icon"
      transform="translate(0 0)"
    >
      <g
        id="Gruppe_25817"
        data-name="Gruppe 25817"
      >
        <path
          id="Pfad_55738"
          data-name="Pfad 55738"
          d="M0,0V14.44H12.14l.5-1.1a1.469,1.469,0,0,1,.28-.4l.49-.5H2V2.66l9.01,6.43,9-6.43V5.74l.94-.96a2.384,2.384,0,0,1,1.06-.62V0ZM11.01,6.63,4.52,2H17.49Zm7.11,7.81h3.89V10.5Zm5.49-6.99v.01l-.87.87a.035.035,0,0,1-.01.02l-.72.73-2,2.03L18.7,12.44l-1.98,2-1.16,1.18a.273.273,0,0,1-.12.09l-2.41,1.2a.647.647,0,0,1-.2.04.476.476,0,0,1-.34-.14.492.492,0,0,1-.1-.54l.84-1.83.3-.65a.5.5,0,0,1,.1-.14l1.19-1.21,5.19-5.27,1.66-1.68a1.2,1.2,0,0,1,.34-.25,1.22,1.22,0,0,1,.62-.16,1.333,1.333,0,0,1,.96.41,1.4,1.4,0,0,1,.02,1.96"
          fill="currentColor"
        />
      </g>
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconMessageAdd' };
</script>